"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ClickOutside;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useClickOutside = _interopRequireDefault(require("./use-click-outside"));

/**
 * @param {Object} props props
 * @param {function} props.onclick outside handler
 * @param {object} props.targetRef parent ref
 * @returns {React.ReactComponent} HOC component for handling clicks outside
 */
function ClickOutside(_ref) {
  let {
    onClick,
    children,
    targetRef
  } = _ref;
  (0, _useClickOutside.default)(targetRef, onClick);
  return children;
}

ClickOutside.propTypes = {
  /** Event handler */
  onClick: _propTypes.default.func.isRequired,

  /** needs to be a React.createRef */
  targetRef: _propTypes.default.object.isRequired,

  /** remaining elements to render */
  children: _propTypes.default.node
};